export enum ItaEnvironment {
    SBX = 'SBX',
    DEV = 'DEV',
    SIT = 'SIT',
    UAT = 'UAT',
    PRE = 'PRE',
    PRD = 'PRD'
}